"use client";

import { ComponentProps, FC } from "react";

import { Content as BuilderContent } from "@builder.io/sdk-react";

import { env } from "@/env";

import { BuilderModels } from "./builder.models.types";
import { customComponents } from "./components-registry";

export type ContentProps = Omit<
  ComponentProps<typeof BuilderContent>,
  "apiKey" | "model"
> & {
  model: BuilderModels;
};

export const Content: FC<ContentProps> = (props) => {
  return (
    <BuilderContent
      {...props}
      apiKey={env.builderApiKey}
      customComponents={customComponents}
      enrich={true}
    />
  );
};
